import { Label as Lbl, LabelProps } from '@apia/theme';

export const Label = ({ variant, ...props }: LabelProps) => (
  <Lbl sx={{ variant }} {...props} />
);
